import {list} from '@/domain/bem/services/checklistSecao'
import window from './window/window.js'

export default {
  pageTitle: 'Seção dos Checklists de Bens',
  columns: [
    {
      name: 'nome',
      required: true,
      label: 'Seção',
      align: 'left',
      field: 'name',
      sortable: true,
      parser: function (props) {
        return props.nome
      }
    },
    {
      name: 'codigo',
      required: true,
      label: 'Código',
      align: 'left',
      field: 'codigo',
      sortable: true,
      parser: function (props) {
        return props.codigo
      }
    },
    {
      name: 'active',
      required: true,
      label: 'Situação',
      align: 'left',
      field: 'active',
      sortable: true,
      parser: function (props) {
        return props.active ? 'Ativo' : 'Inativo'
      }
    },
    {
      name: 'options',
      required: true,
      label: '',
      field: 'options',
      sortable: false
    }
  ],
  resolve: list,
  methods: {
    // window: window
    abrir: function (id) {
      window.call(this, {id: id, table: this.table})
    },
    novo: function () {
      window.call(this, {})
    }
  }
}
